// Pure helpers for Google sign-in. No Firebase imports, so tests can cover
// the messages and the popup-blocked decision without starting Auth.

export function isPopupBlockedError(error) {
  return error?.code === 'auth/popup-blocked';
}

export function pathAfterSignIn({ type, emailVerified }) {
  if (!emailVerified) return '/verify-email';
  return type === 'customer' ? '/customer-dashboard' : '/provider-dashboard';
}

// Where to go after a successful sign-up submit.
// null means stay on the "check your email" countdown (email/password sign-up).
// A verified Google account goes straight to the dashboard.
export function signupSuccessPath(result) {
  if (!result?.success) return null;
  if (result.existing || result.emailVerified) {
    return pathAfterSignIn({ type: result.type, emailVerified: result.emailVerified });
  }
  if (result.verificationSent === false) return '/verify-email';
  return null;
}

export function googleAccountExistsMessage(email) {
  const who = email ? ` (${email})` : '';
  return `An account already exists for this email address${who} with a password. Sign in with your email and password. Signing in with the same email links Google to that account.`;
}

// Returns a message for Google-specific failures, or '' so the caller can use
// the shared auth error text.
export function explainGoogleError(error) {
  if (error?.code === 'auth/account-exists-with-different-credential') {
    return googleAccountExistsMessage(error.customData?.email);
  }
  return '';
}
